import React from "react";
import useAxios from "../../../hooks/useAxios";
import { listItems, showEmpty, SystemTableCard } from "../system/SystemPageUtils";

export default function DocumentBoard() {
  const [resp, error, loading] = useAxios({
    method: "GET",
    url: "/documents/recent",
    auth: true,
  });

  const items = listItems(resp);
  const columns = ["no", "document_name", "entity_code", "nomor_dokumen", "file_name"];
  const coltype = {
    no: { label: "No", width: 50, align: "center" },
    document_name: { label: "Jenis Dokumen" },
    entity_code: { label: "Entitas", align: "center" },
    nomor_dokumen: { label: "Nomor Dokumen", renderFunc: (val) => showEmpty(val) },
    file_name: { label: "Nama File", renderFunc: (val) => showEmpty(val) },
  };

  return (
    <SystemTableCard
      title="Dokumen Terbaru"
      description="Daftar dokumen terbaru yang dapat diakses user aktif."
      data={items}
      dlist={{ columns, sort_by: [] }}
      paging={{ page: 1, perpage: Math.max(items.length || 1, 10) }}
      coltype={coltype}
      loading={loading}
      error={error ? `Gagal memuat dokumen: ${error}` : ""}
    />
  );
}
